import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/ui/status-badge";
import SceltaCliente from "@/components/common/SceltaCliente";
import { giornoDi, giornoLungo } from "@/lib/crm";

const Riga = ({ etichetta, valore }) => (
  <div className="flex justify-between gap-group text-small">
    <dt className="text-ink-2">{etichetta}</dt>
    <dd className="text-right font-bold text-ink">{valore}</dd>
  </div>
);

/**
 * La scheda a destra della chat. Con un cliente: nome, fase, sede e chi lo segue, e il passaggio alla scheda
 * vera. Senza: «Non è in archivio», con «Aggiungi come cliente» (si apre «Nuovo cliente» con nome e numero già
 * scritti) o l'aggancio a un cliente che c'è già. Un cliente che chi guarda non vede non mostra niente di suo.
 */
export default function SchedaCliente({ filo, onAggiungi, onAggancia }) {
  const { contatto, cliente } = filo;

  if (!cliente) {
    return (
      <div className="grid grid-cols-1 content-start gap-group" data-testid="scheda-senza-cliente">
        <p className="text-caption font-bold text-warning-ink">Non è in archivio</p>
        <div>
          <h3 className="[overflow-wrap:anywhere] font-display text-h3 text-ink-strong">{contatto.nome}</h3>
          <p className="mt-micro text-small text-ink-2">
            {contatto.first_seen_at ? `Primo messaggio ${giornoLungo(giornoDi(contatto.first_seen_at))}.` : "Primo messaggio da poco."} Non è collegato a nessun cliente.
          </p>
        </div>
        <Button onClick={onAggiungi} data-testid="filo-aggiungi-cliente">
          Aggiungi come cliente
        </Button>
        <p className="text-small text-ink-2">Si apre «Nuovo cliente» con il numero e la provenienza WhatsApp già scritti.</p>
        <div className="mt-group grid gap-inside border-t border-line-subtle pt-group">
          <p className="text-small text-ink-2">Se è già un cliente, collegalo.</p>
          <SceltaCliente valore={null} onScegli={onAggancia} testId="filo-aggancia" segnaposto="Aggancia a un cliente" />
        </div>
      </div>
    );
  }

  if (!cliente.nome) {
    return (
      <div className="grid content-start gap-group" data-testid="scheda-cliente-non-visibile">
        <p className="text-caption font-bold text-ink-2">Cliente</p>
        <p className="text-small text-ink-2">È collegata a un cliente che non segui tu: la scheda la apre chi lo segue.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 content-start gap-group" data-testid="scheda-cliente">
      <p className="text-caption font-bold text-ink-2">Cliente</p>
      <div className="grid justify-items-start gap-inside">
        <h3 className="max-w-full [overflow-wrap:anywhere] font-display text-h3 text-ink-strong">{cliente.nome}</h3>
        {cliente.stato_label ? <StatusBadge tone="brand">{cliente.stato_label}</StatusBadge> : null}
      </div>
      <dl className="grid gap-inside">
        {cliente.sede ? <Riga etichetta="Sede" valore={cliente.sede} /> : null}
        <Riga etichetta="Conversazione" valore={contatto.segue ? `Segue ${contatto.segue}` : "Senza nessuno"} />
      </dl>
      <Button asChild variant="secondary">
        <Link to={`/clienti/${cliente.id}`} data-testid="filo-scheda">
          Apri la scheda
        </Link>
      </Button>
    </div>
  );
}
